import { render, staticRenderFns } from "./Lupatakalaluan.vue?vue&type=template&id=3804cbc4"
import script from "./Lupatakalaluan.vue?vue&type=script&lang=js"
export * from "./Lupatakalaluan.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports